import { NavLink, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import LanguageSwitcher from "../../LanguageSwitcher";

import "./index.css";

const Menu = ({ handleToggleMenu }) => {
  const { t: translation } = useTranslation();

  return (
    <div className="menu display-mobile">
      <NavLink className="menu__link" to="/" onClick={handleToggleMenu}>
        {translation("navbar.homeNavLinK")}
      </NavLink>

      <NavLink className="menu__link" to="/about" onClick={handleToggleMenu}>
        {translation("navbar.whyNetifyNavLinK")}
      </NavLink>

      <NavLink className="menu__link" to="/pricing" onClick={handleToggleMenu}>
        {translation("navbar.pricingNavLinK")}
      </NavLink>

      <NavLink className="menu__link" to="/contact" onClick={handleToggleMenu}>
        {translation("navbar.contactNavLinK")}
      </NavLink>

      <NavLink
        className="menu__link"
        to="/compatibility"
        onClick={handleToggleMenu}
      >
        {translation("navbar.compatibilityNavLinK")}
      </NavLink>

      <NavLink
        className="menu__link"
        to="/frequently-asked-questions"
        onClick={handleToggleMenu}
      >
        {translation("navbar.faqsNavLinK")}
      </NavLink>

      <Link
        className="menu__link"
        to="/#how-it-works"
        onClick={handleToggleMenu}
      >
        {translation("navbar.howItWorksNavLinK")}
      </Link>

      <NavLink
        className="menu__link"
        to="/grow-with-us"
        onClick={handleToggleMenu}
      >
        {translation("navbar.growWithUsNavLinK")}
      </NavLink>

      <NavLink className="menu__link" to="/login" onClick={handleToggleMenu}>
        {translation("navbar.singInNavLinK")}
      </NavLink>

      <LanguageSwitcher
        sx={{
          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            padding: 0,
          },
          "& fieldset": {
            border: "unset",
          },
        }}
      />

      <button type="button" className="closeButton" onClick={handleToggleMenu}>
        <div className="closeButton_bar1"></div>
        <div className="closeButton_bar2"></div>
      </button>
    </div>
  );
};

export default Menu;
